import { render, staticRenderFns } from "./personCenter.vue?vue&type=template&id=c2f3b6a2&scoped=true"
import script from "./personCenter.vue?vue&type=script&lang=ts"
export * from "./personCenter.vue?vue&type=script&lang=ts"
import style0 from "./personCenter.vue?vue&type=style&index=0&id=c2f3b6a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f3b6a2",
  null
  
)

export default component.exports